/* eslint-disable */
// @ts-nocheck
import cx from 'classnames'
import dynamic from 'next/dynamic'
import { useInView } from 'react-intersection-observer'
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
} from 'react'
import Cookies from 'universal-cookie'
import {
  clientConfig,
  getAdDeviceType,
  isAndroidApp,
  isDesktop,
  isIosApp,
  isMobile,
  isNativeApp,
} from '../../../client'
import {
  useGooglePal,
  usePage,
  usePageViewInDay,
  usePageVisibility,
} from '../../../contexts'
import { usePlayerStore, useRootStore } from '../../../store'
import {
  getParameterByName,
  getPpid,
  getUuid,
  isUserLoggedIn,
  prettyLog,
  sendGA4,
  setImaPpid,
  setOmidEvents,
} from '../../../utils'
import {
  default_player_progress_report_map,
  DfpTimer,
  dfpUtils,
  PLAYER_EVENT,
  playerConfig,
  subtitlesData,
  Timer,
  useEventListener,
  useLiveSource,
  utils,
} from '../Helpers'
import ReactDOM from 'react-dom'
import { IShareConfig, KalturaProps, PlayerState } from '../Models/PlayerModels'
import { PlayerContext } from '../Store/PlayerContext'
import { ImgWithRatio } from '../Styles/Player.styles'
import { KlaturaPlayerDiv, KlaturaPlayerWrp } from './Kaltura.styles'
import { config } from '../../../lib'
import { AdS, INextVideos } from '../../../types'
import {
  Loader,
  NextVideoTimerScreen,
  RegistrationFormCTA,
} from '../components'
import { kalturaConfig } from '../Helpers/kaluraConfig'
import { GradientContainer } from '../components/PlayerMarqueTitle.styles'
import { useUnmount } from '../../../hooks/useUnmount'

const PlayerMarqueTitle = dynamic(
  () => import('../components/PlayerMarqueTitle')
)

export const Kaltura: React.FC<KalturaProps> = props => {
  const { playerScript } = useRootStore()
  const isLiveVideo = useMemo(
    () => !!utils.isLive(props.videoRef),
    [props.videoRef]
  )
  const [kalturaContainer, setKalturaContainer] = useState<HTMLElement | null>(
    null
  )
  // Stable element for PAL's size measurement only - set once from the outer
  // wrapper ref (same pattern as Ott/Components/Player's setOttPlayerRef),
  // NOT from kalturaContainer below. kalturaContainer is re-queried from
  // Kaltura's own internal DOM (which KalturaPlayer.setup() regenerates on
  // every rebuild) and also doubles as a portal target for the title overlay,
  // so feeding it to useGooglePal would give PAL a "new" element every
  // rebuild, trigger a fresh nonce, and re-trigger the rebuild - an infinite
  // loop. The outer wrapper node, by contrast, is owned by React and stays
  // the same DOM node across Kaltura-internal rebuilds.
  const [palVideoElement, setPalVideoElement] = useState<HTMLElement | null>(
    null
  )
  const googlePal = useGooglePal({
    adWillAutoPlay: props.autoPlay,
    kalturaReady: playerScript.kalturaReady,
    continuousPlayback: isLiveVideo,
    videoElement: palVideoElement,
  })
  // Feedback-loop guard: the kaltura config effect below reads this via ref
  // instead of depending on `googlePal` directly. That effect creates a new
  // `.kaltura-player-container` DOM node every time it runs, which becomes
  // the next `videoElement` passed to useGooglePal above, which produces a
  // brand-new PAL nonce, which would change `googlePal` and re-trigger this
  // same effect - an infinite rebuild loop. Live pages still get a fresh
  // pal value through the useLiveSource hook, which already gates on
  // googlePal before this effect is allowed to run the first time.
  const googlePalRef = useRef(googlePal)
  useEffect(() => {
    googlePalRef.current = googlePal
  }, [googlePal])
  const enable_full_screen = config.enable_full_screen != 'disabled'
  // Same getPpid() every other ad call site uses (the PAL nonce request, the
  // display setPublisherProvidedId, the ad-tag builders in constants.ts), so
  // GAM can correlate one user across video and display. It is also the value
  // the live manifest URL carries as player.ppid - these must not diverge.
  const ppid = useMemo(() => getPpid(), [])
  const progress_report_map = useMemo(
    () => [...default_player_progress_report_map],
    []
  )
  const [shouldLog, setShouldLog] = useState(false)
  const [state, setState] = useReducer(
    (state: PlayerState, newState: Partial<PlayerState>) => ({
      ...state,
      ...newState,
    }),
    {
      showLoader: false,
      isErrorVideoLoad: false,
      isErrorOverseas: false,
      loadTaboola: false,
      isKalturaPicInPic: false,
      isPicInPic: false,
      isTaboolaInView: false,
      timer: null,
      isPlayingdInMobile: false,
      afterScrollPauseMobile: false,
      afterPageIsNotVisible: false,
      wasPaused: true,
      adsFetched: false,
      playBackStart: false,
    }
  )
  const pageData = usePage()
  const [kalturaPlayer, setKalturaPlayer] = useState<any>(null)
  const [beforePlaying, setBeforePlaying] = useState<boolean>(true)
  // const { manifestUrl, trackingUrl } = useLiveSourceManifest(liveSource)
  const [dfp_timer] = useState(new DfpTimer())
  const [nextVideoTimer] = useState(new DfpTimer())
  const [counterTimeWatch] = useState(new DfpTimer())
  const [videoEnded, setVideoEnded] = useState<boolean>()
  const [delayTimeEnded, setDelayTimeEnded] = useState<boolean>(false)
  const [replayClicked, setReplayClicked] = useState<boolean>(false)
  const [displayMarqueTitle, setDisplayMarqueTitle] = useState<'flex' | 'none'>(
    'none'
  )
  const isComponentMounted = useRef(true)
  const [showNextVideoSLide, setShowNextVideoSlide] = useState<boolean>(false)
  const playNextVideoInterval = useMemo(() => {
    if (pageData.SiteMeta.config?.player.nextVideoCounter) {
      return pageData.SiteMeta.config?.player.nextVideoCounter
    }
    return 6
  }, [])
  const replayVideo = useRef<string>(pageData?.Content.Item?.video?.kalturaId)
  const NextVideoTimerScreenMarqueTitle = useRef<string>(
    pageData?.Content.Item?.video?.description || pageData?.Content.Item?.title
  )
  const kalturaRef = useRef<HTMLHeadingElement>(null)
  const adStorage = useRef<AdS>([])
  const videos = useRef<INextVideos>(pageData?.Content.Item?.video?.nextVideos)
  const isAdPlaying = useRef<boolean>(false)
  const adPlayerStatus = useRef<'paused' | 'playing' | 'ended' | 'not_playing'>(
    'not_playing'
  )
  const interval = useRef<NodeJS.Timeout>()
  const marqueTitleTimeout = useRef<NodeJS.Timeout>()
  const playNextVideoIsOn = pageData?.SiteMeta.config?.play_next_episode
  const autoPlayedItemsCounter = useRef<number>(1)
  const isPaused = useRef(false)
  const {
    setPlayerStatePaused,
    playerStatePaused,
    setPlayerTitle,
    playerTitle,
    googlePalReady,
  } = usePlayerStore()
  const playerCtx = useContext(PlayerContext)
  const {
    targetPlayNowArr,
    setTargetPlayingNow,
    setVideoPlaying,
    setVideoEndedId,
  } = playerCtx
  const pageViewedInDay = usePageViewInDay()
  const {
    kalturaId,
    pageType,
    inChanel26,
    videoRef,
    contentDuration,
    blockRT,
    country,
    poster,
    loadKantarConfig,
    levels,
    autoPlay,
    targetId,
    defaultImages,
    item,
    playerOnly,
    title,
    fromParser,
  } = props

  const outOfViewPaused = useRef<boolean>(false)
  // Add an intersection observer to track player visibility
  const { ref: intersectionRef, inView } = useInView({
    threshold: 0.5, // 50% visibility threshold
    rootMargin: isNativeApp() ? '-20px 0px 0px 0px' : '-100px 0px 0px 0px', // Offset 100px from top for header
    trackVisibility: true,
    delay: 100,
  })

  // Combine refs for the player wrapper
  const setRefs = useCallback(
    (node: HTMLHeadingElement | null) => {
      intersectionRef(node)
      setPalVideoElement(node)
    },
    [intersectionRef]
  )

  const G_CLICK_URL = useRef<null | string>(null) // Initialize g click URL

  useEffect(() => {
    const shouldLogFlag =
      getParameterByName('log_kaltura') === 'true' ||
      !!sessionStorage.getItem('log_kaltura')
    shouldLogFlag && sessionStorage.setItem('log_kaltura', 'true')
    setShouldLog(shouldLogFlag)
  }, [])

  const kantarSiteName = useMemo(() => {
    if (pageData) {
      const siteNames = pageData.SiteMeta.config?.player?.kantar?.site_name
      if (siteNames) {
        if (isDesktop()) {
          return siteNames.desktop
        }
        if (isIosApp()) {
          return siteNames.ios_app
        }
        if (isAndroidApp()) {
          return siteNames.android_app
        }
        return siteNames.mobile
      }
    }
    return null
  }, [pageData])

  const DFP_ADS_ON = useMemo(
    () =>
      !blockRT &&
      playerConfig.DFPParams.DFP_ON &&
      !(getParameterByName('noVideoDFP') === 'yes'),
    []
  )

  const { defaultImg, overseasImg } = useMemo(() => {
    const defaultImg = utils.isNews()
      ? defaultImages.news.unavailable
      : defaultImages.tv.unavailable
    // Geo-block placeholder: always the same image as OTT (RESH13-1097),
    // regardless of news/tv page type.
    const overseasImg = defaultImages.tv.overseas
    return { defaultImg, overseasImg }
  }, [])

  const DFP_Timer_BB = playerConfig.DFPParams.timer_BB * 60000 //milliseconds
  const isPageVisible = usePageVisibility()

  const playAdNow = useCallback(
    (adType: 'preroll' | 'midroll') => {
      if (kalturaPlayer) {
        const ad = dfpUtils.getAdVideo({
          pagetypeMeta: pageType,
          pageType: 'bb',
          adType,
          levels,
          pageViewedInDay: pageViewedInDay.pageViewInDayCount,
          item,
          referenceId: videoRef,
        })
        kalturaPlayer.ads.playAdNow([{ url: [ad] }])
      }
    },
    [kalturaPlayer, pageType, levels, pageViewedInDay.pageViewInDayCount, item]
  )

  const resetAfterMidroll = useCallback(() => {
    if (kalturaPlayer) {
      kalturaPlayer.plugins.ima.reset()
      kalturaPlayer.plugins.ima.loadMedia()
    }
  }, [kalturaPlayer])

  const ERROR_HANDLER = useCallback(
    (ev: any) => {
      if (kalturaPlayer) {
        const err = ev.payload

        if (err.code === 1002 && err.data.name === 'manifestLoadError') {
          setState({ isErrorVideoLoad: true })
        }

        if (parseInt(err.code) === 7002) {
          prettyLog('Kaltura: 185', err, 'error')

          if (parseInt(err.data.code) === 2001) {
            // country_restricted: show the overseas image. It used to flip the
            // r13_geo cookie and reload, but nothing reads that cookie any
            // more: a reload loop with it, a crash (no image) without it
            setState({
              isErrorVideoLoad: true,
              isErrorOverseas: true,
            })
          } else {
            setState({ isErrorVideoLoad: true })
          }
        }
      }
    },
    [
      kalturaPlayer,
      autoPlay,
      contentDuration,
      country,
      kalturaId,
      pageData,
      videoRef,
    ]
  )
  useEventListener(PLAYER_EVENT.ERROR, ERROR_HANDLER, kalturaPlayer)

  const FIRST_PLAY_HANDLER = useCallback(() => {
    sendGA4({
      eventName: `Video_content_start_${isLiveVideo ? 'live' : '1010'}`,
      pageData: pageData,
      video_duration: contentDuration,
      ReferenceId: videoRef,
      is_autoplay: autoPlay ? 'yes' : 'no',
    })

    setVideoEnded(false)
    setDelayTimeEnded(false)
    setBeforePlaying(false)

    if (kalturaPlayer) {
      // if (
      //   !omidManagerRef.current &&
      //   (
      //     kalturaPlayer as KalturaPlayer & { _localPlayer?: ILocalPlayer }
      //   )?._localPlayer?._el?.querySelector('video')
      // ) {
      //   // if (typeof OmidManager === 'function') {
      //   //   // const localPlayer = (
      //   //   //   kalturaPlayer as KalturaPlayer & { _localPlayer?: ILocalPlayer }
      //   //   // )._localPlayer
      //   //   // const videoElement = localPlayer?._el?.querySelector(
      //   //   //   'video'
      //   //   // ) as HTMLVideoElement | null
      //   //   // if (!videoElement) {
      //   //   //   return
      //   //   // }
      //   //   // try {
      //   //   //   omidManagerRef.current = new OmidManager(videoElement)
      //   //   //
      //   //   //   if (trackingData) {
      //   //   //     omidManagerRef.current.setAdTrackingData(trackingData)
      //   //   //   }
      //   //   // } catch (error) {
      //   //   //   console.error(
      //   //   //     'first play OMID: Error initializing manager in FIRST_PLAY_HANDLER:',
      //   //   //     error
      //   //   //   )
      //   //   // }
      //   // } else {
      //   //   console.error(
      //   //     'first play OMID: OmidManager class not available in FIRST_PLAY_HANDLER'
      //   //   )
      //   // }
      // }

      // const hls = (
      //   kalturaPlayer as KalturaPlayer & { _localPlayer?: ILocalPlayer }
      // )._localPlayer?._engine?._mediaSourceAdapter?._hls

      // if (hls && omidManagerRef.current) {
      //   /**
      //    * Handles the 'hlsFragChanged' event from the HLS.js player.
      //    * This event is triggered when the video fragment changes during playback.
      //    * Extracts the fragment sequence number (sn) from the event arguments and
      //    * notifies the OMID manager of the fragment change for ad/session tracking and omid verification.
      //    */
      //   hls.on('hlsFragChanged', (...args: unknown[]) => {
      //     const obj = args[1] as { frag?: { sn?: string | number } }
      //     if (obj?.frag?.sn) {
      //       const fragSn = obj.frag.sn.toString()
      //       if (omidManagerRef.current) {
      //         omidManagerRef.current.handleFragmentChange(fragSn)
      //       }
      //     }
      //   })
      //
      //   /**
      //    * Handles the 'hlsLevelLoaded' event from the HLS.js player.
      //    * This event is triggered when the video level is loaded for fetching the tracking data.
      //    */
      //   hls.on('hlsLevelLoaded', LOADED_METADATA_HANDLER)
      // }

      if (DFP_ADS_ON) {
        dfp_timer.start()
      }
      //TO CHECK
      // clearTimeout(window.refreshTimeOut);
      // clearTimeout(window.analiticsInterval);
      if (utils.isLivePage(pageType) || isLiveVideo || inChanel26) {
        setTimeout(() => {
          try {
            kalturaPlayer.seekToLiveEdge()
          } catch (e) {
            prettyLog('Kaltura: 254', e, 'error')
          }
        }, 50)
        kalturaPlayer.ui.getManager('timeline').setSeekbarPreview({
          hideTime: true,
          label: 'Dvr Time Component',
          presets: ['Live'],
          area: 'SeekBar',
          replaceComponent: 'SeekBarPreview',
          get: utils.dvrTimeComponent(KalturaPlayer),
          className: 'dvr-time',
          width: 35,
          height: 22,
        })
        counterTimeWatch.start()
      }

      //TODO
      // if (isLivePage(pageType)) {
      //     this.surveyTimer.resume();
      // }
    }
  }, [
    kalturaPlayer,
    pageType,
    videoRef,
    inChanel26,
    pageData,
    contentDuration,
    autoPlay,
  ])
  useEventListener(PLAYER_EVENT.FIRST_PLAY, FIRST_PLAY_HANDLER, kalturaPlayer)

  const PLAY_HANDLER = useCallback(() => {
    dfp_timer.resume()
    counterTimeWatch.resume()
    setPlayerStatePaused(false)
    handleMouseMove()
    if (kalturaPlayer) {
      if (state.isKalturaPicInPic && targetPlayNowArr[0] !== targetId) {
        setTargetPlayingNow(targetId, true)
      }
      //TODO TIMER TO PAGE26
      if (inChanel26 && DFP_ADS_ON && state.timer) {
        state.timer.resume()
      }
    }
  }, [
    kalturaPlayer,
    state.isKalturaPicInPic,
    state.timer,
    setTargetPlayingNow,
    targetPlayNowArr,
    targetId,
    DFP_ADS_ON,
    inChanel26,
    videoRef,
  ])
  useEventListener(PLAYER_EVENT.PLAY, PLAY_HANDLER, kalturaPlayer)

  const PAUSE_HANDLER = useCallback(() => {
    setPlayerStatePaused(true)
    if (!state.isPicInPic) {
      setDisplayMarqueTitle('flex')
    }
    dfp_timer.pause()
    counterTimeWatch.pause()
    if (kalturaPlayer) {
      // if (!kalturaPlayer.ads.isAdBreak()) {
      // setVideoPlaying(false)
      // }
      //TODO
      if (inChanel26 && DFP_ADS_ON && state.timer) {
        state.timer.pause()
      }
    }
  }, [
    kalturaPlayer,
    state.timer,
    DFP_ADS_ON,
    inChanel26,
    videoRef,
    videos.current,
  ])
  useEventListener(PLAYER_EVENT.PAUSE, PAUSE_HANDLER, kalturaPlayer)

  const GA4VideoStartEvent = () => {
    sendGA4({
      eventName: isLiveVideo
        ? 'Video_video_start_live'
        : playerOnly
        ? 'Embeded_video_start_1010'
        : 'Video_video_start_1010',
      pageData: pageData,
      video_duration: contentDuration,
      ReferenceId: videoRef,
      is_autoplay: autoPlay ? 'yes' : 'no',
    })
  }

  const PLAYBACK_START_HANDLER = useCallback(() => {
    setVideoPlaying(true)
    adPlayerStatus.current = 'ended'
    if (kalturaPlayer) {
      setState({ showLoader: true, playBackStart: true })
      //TODO
      // if (isLivePage(pageType)) {
      //     this.surveyTimer = new Timer(() => {
      //         this.props.showSurvey();
      //     }, 30000, "survey")
      // }

      GA4VideoStartEvent()
      // prettyLog('Kaltura: 509', {
      //   DFP_ADS_ON,
      //   isLiveVideo,
      //   adStorage: adStorage.current,
      // })
      if (DFP_ADS_ON) {
        if (!isLiveVideo) {
          if (
            adStorage.current &&
            adStorage.current.length > 0 &&
            adStorage.current[0].preroll
          ) {
            const shiftedAd = adStorage.current.shift()
            if (shiftedAd?.preroll) {
              playAd(shiftedAd.preroll.ad)
            }
          } else {
            prettyLog(
              'Kaltura: 493',
              'There is no preroll, response empty',
              'error'
            )
          }
        }
        //show preroll
        if (inChanel26) {
          playAdNow('preroll')
        }
      }
      handleMouseMove()
    }
  }, [
    kalturaPlayer,
    videoRef,
    playerOnly,
    pageData,
    contentDuration,
    autoPlay,
    inChanel26,
    DFP_ADS_ON,
    playAdNow,
  ])

  useEventListener(
    PLAYER_EVENT.PLAYBACK_START,
    PLAYBACK_START_HANDLER,
    kalturaPlayer
  )

  const PLAYBACK_ENDED_HANDLER = useCallback(() => {
    dfp_timer.stop()
    setAdsCollection()
    interval.current && clearTimeout(interval.current)
    setVideoEnded(true)
    setVideoEndedId(kalturaId)
    if (kalturaPlayer) {
      if (playNextVideoIsOn) {
        nextVideoTimer.start()
        if (Object.entries(videos.current).length > 0) {
          interval.current = setTimeout(
            playNextVideo,
            playNextVideoInterval * 1000
          )
        }
      }
      sendGA4({
        eventName: 'Video_video_reach_100',
        pageData: pageData,
        video_duration: contentDuration,
        ReferenceId: videoRef,
        is_autoplay: autoPlay ? 'yes' : 'no',
      })
    }
  }, [
    kalturaPlayer,
    pageData,
    contentDuration,
    videoRef,
    autoPlay,
    setVideoEndedId,
    kalturaId,
  ])
  useEventListener(
    PLAYER_EVENT.PLAYBACK_ENDED,
    PLAYBACK_ENDED_HANDLER,
    kalturaPlayer
  )

  const LOADED_METADATA_HANDLER = useCallback(() => {
    if (kalturaPlayer) {
      setState({ showLoader: false })
    }

    // /**
    //  * Handles the 'hlsLevelLoaded' event from the HLS.js player.
    //  * Fetches ad tracking data from the tracking URL and updates the OMID manager with this data for ad verification.
    //  * If the OMID manager is not available, logs a message and sets the tracking data later when available.
    //  */
    // if (trackingUrl) {
    //   fetch(trackingUrl)
    //     .then(resp => resp.json())
    //     .then(data => {
    //       setTrackingData(data)
    //       // if (omidManagerRef.current) {
    //       //   omidManagerRef.current.setAdTrackingData(data)
    //       // } else {
    //       //   prettyLog(
    //       //     'OMID: Manager not available yet, tracking data will be set later',
    //       //     'error'
    //       //   )
    //       // }
    //     })
    //     .catch(e => {
    //       prettyLog('Tracking data fetch failed:', e, 'error')
    //     })
    // }
  }, [kalturaPlayer])

  useEventListener(
    PLAYER_EVENT.Core.LOADED_METADATA,
    LOADED_METADATA_HANDLER,
    kalturaPlayer
  )

  const WAITING_HANDLER = useCallback(() => {
    if (kalturaPlayer) {
      setState({ showLoader: true })
    }
  }, [kalturaPlayer])
  useEventListener(PLAYER_EVENT.Core.WAITING, WAITING_HANDLER, kalturaPlayer)

  const AD_MANIFEST_LOADED_HANDLER = useCallback(
    (ev: any) => {
      if (kalturaPlayer) {
        shouldLog &&
          prettyLog('Kaltura: 599', {
            ev: 'AD_MANIFEST_LOADED_HANDLER',
            payload: ev.payload,
          })
      }
    },
    [kalturaPlayer]
  )
  useEventListener(
    PLAYER_EVENT.Core.AD_MANIFEST_LOADED,
    AD_MANIFEST_LOADED_HANDLER,
    kalturaPlayer
  )

  // const AD_LOADED_HANDLER = useCallback(
  //   (ev: any) => {
  //     shouldLog &&
  //       prettyLog('Kaltura: 612', {
  //         ev: 'AD_LOADED_HANDLER',
  //         payload: ev.payload,
  //       })
  //   },
  //   [kalturaPlayer]
  // )
  // useEventListener(
  //   PLAYER_EVENT.Core.AD_LOADED,
  //   AD_LOADED_HANDLER,
  //   kalturaPlayer
  // )

  const PROGRESS_HANDLER = useCallback(() => {
    if (!isLiveVideo) {
      if (
        adPlayerStatus.current !== 'playing' &&
        DFP_ADS_ON &&
        Object.entries(adStorage.current).length &&
        adStorage.current[0].midroll?.timeOffset
      ) {
        if (
          dfp_timer.getState().time >= adStorage.current[0].midroll.timeOffset
        ) {
          adPlayerStatus.current = 'playing'
          const shiftedAd = adStorage.current.shift()
          if (shiftedAd?.midroll) {
            playAd(shiftedAd.midroll.ad)
          }
        }
      }
    }
    if (
      !isLiveVideo &&
      progress_report_map[0] < kalturaPlayer?.currentTime / contentDuration
    ) {
      sendGA4({
        eventName: `Video_video_reach_${progress_report_map[0] * 100}`,
        pageData: pageData,
        video_duration: contentDuration,
        ReferenceId: videoRef,
        is_autoplay: autoPlay ? 'yes' : 'no',
      })

      progress_report_map.shift()
    }
  }, [
    autoPlay,
    contentDuration,
    kalturaPlayer?.currentTime,
    pageData,
    progress_report_map,
    videoRef,
  ])
  useEventListener(PLAYER_EVENT.TIME_UPDATE, PROGRESS_HANDLER, kalturaPlayer)

  const AD_STARTED_HANDLER = useCallback(() => {
    adPlayerStatus.current = 'playing'
    if (kalturaPlayer) {
      isAdPlaying.current = true
      setState({ showLoader: false, isAdPlaying: true })

      //TODO
      if (inChanel26 && DFP_ADS_ON && state.timer) {
        state.timer.pause()
      }
    }
  }, [kalturaPlayer, state.timer, inChanel26, DFP_ADS_ON])
  useEventListener(
    PLAYER_EVENT.Core.AD_STARTED,
    AD_STARTED_HANDLER,
    kalturaPlayer
  )

  const AD_RESUMED_HANDLER = useCallback(() => {
    adPlayerStatus.current = 'playing'
    if (kalturaPlayer) {
      setVideoPlaying(true)
      isAdPlaying.current = true
      if (targetPlayNowArr[0] !== targetId) {
        setTargetPlayingNow(targetId, true)
      }
    }
  }, [
    kalturaPlayer,
    setTargetPlayingNow,
    targetPlayNowArr,
    targetId,
    setVideoPlaying,
    videoRef,
  ])

  useEventListener(
    PLAYER_EVENT.Core.AD_RESUMED,
    AD_RESUMED_HANDLER,
    kalturaPlayer
  )

  const AD_PAUSED_HANDLER = useCallback(() => {
    if (kalturaPlayer) {
      isAdPlaying.current = false
      adPlayerStatus.current = 'paused'
    }
  }, [kalturaPlayer, videoRef])

  useEventListener(
    PLAYER_EVENT.Core.AD_PAUSED,
    AD_PAUSED_HANDLER,
    kalturaPlayer
  )

  const AD_BREAK_START_HANDLER = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    () => {
      adPlayerStatus.current = 'playing'
      dfp_timer.pause()
      counterTimeWatch.pause()
      if (kalturaPlayer) {
        //TODO
        // console.log('%cKaltura ad event\n%cAD_BREAK_START', 'background-color:black;color:white;padding:2px 5px;', 'background-color:lime;padding: 2px 5px;', ev.payload);
        // this.props.adStateChanged("on");
        // const {adBreak} = ev.payload;
        // switch (adBreak._type) {
        //     case "preroll":
        //         this.adType = "Pre-Roll"
        //         if (isLivePage(pageType)) {
        //             this.surveyTimer.pause();
        //         }
        //         break
        //     case "midroll":
        //         this.adType = "Mid-Roll"
        //         break
        //     case "postroll":
        //         this.adType = "Post-Roll"
        //         break
        // }

        setState({ isAdPlaying: true })
        isAdPlaying.current = true
      }
    },
    [kalturaPlayer]
  )
  useEventListener(
    PLAYER_EVENT.Core.AD_BREAK_START,
    AD_BREAK_START_HANDLER,
    kalturaPlayer
  )

  const AD_BREAK_END_HANDLER = useCallback(() => {
    adPlayerStatus.current = 'ended'
    counterTimeWatch.resume()
    if (kalturaPlayer) {
      isAdPlaying.current = false
      setState({ isAdPlaying: false })
    }
  }, [kalturaPlayer])

  useEventListener(
    PLAYER_EVENT.Core.AD_BREAK_END,
    AD_BREAK_END_HANDLER,
    kalturaPlayer
  )

  const AD_ERROR_HANDLER = useCallback(
    (ev: any) => {
      prettyLog('Kaltura: AD_ERROR', ev?.payload, 'error')
      adPlayerStatus.current = 'ended'
      isAdPlaying.current = false
      counterTimeWatch.resume()
      if (kalturaPlayer) {
        setState({ isAdPlaying: false, showLoader: false })
        // playAdNow() ads don't reliably resume content on failure -
        // without this the player is left stuck in the ad break forever.
        kalturaPlayer.play()
      }
    },
    [kalturaPlayer]
  )
  useEventListener(PLAYER_EVENT.Core.AD_ERROR, AD_ERROR_HANDLER, kalturaPlayer)

  const ADS_COMPLETED_HANDLER = useCallback(() => {
    adPlayerStatus.current = 'ended'
    if (kalturaPlayer) {
      //show midroll
      if (inChanel26 && DFP_ADS_ON) {
        const timer = new Timer(() => {
          resetAfterMidroll()
          playAdNow('midroll')
        }, DFP_Timer_BB)
        setState({ timer: timer })
      }
    }
  }, [
    kalturaPlayer,
    inChanel26,
    DFP_ADS_ON,
    DFP_Timer_BB,
    resetAfterMidroll,
    playAdNow,
  ])
  useEventListener(
    PLAYER_EVENT.Core.ADS_COMPLETED,
    ADS_COMPLETED_HANDLER,
    kalturaPlayer
  )

  /**
   * If the G_CLICK_URL is defined, open it in a new window
   */
  const handleGClick = () => {
    if (G_CLICK_URL.current) {
      window.open(G_CLICK_URL.current)
      setTimeout(() => {
        if (kalturaPlayer.paused) {
          kalturaPlayer.play()
        }
      }, 800)
    }
  }

  const FRAG_FIRST_PLAY_HANDLER = useCallback(() => {
    if (kalturaPlayer?._localPlayer?._engine?._mediaSourceAdapter?._hls) {
      /*
       * Attach click event listener-to-player overlay area
       */
      if (kalturaRef.current) {
        const wrappedElement = document.getElementById(
          kalturaRef.current.id
        ) as HTMLElement
        const interactiveDiv = wrappedElement.querySelector(
          '.playkit-overlay-action'
        ) as HTMLElement

        if (interactiveDiv) {
          interactiveDiv.addEventListener('click', handleGClick)
          interactiveDiv.addEventListener('touchstart', handleGClick, {
            passive: true,
          })
        }
      }

      kalturaPlayer._localPlayer._engine._mediaSourceAdapter._hls.on(
        'hlsFragChanged',
        (data, obj) => {
          const ASSET_TAG = 'EXT-X-ASSET'
          if (obj.frag.tagList.length > 0) {
            for (const [i, tagArr] of obj.frag.tagList.entries()) {
              if (tagArr.length && tagArr[0] == ASSET_TAG) {
                try {
                  /**
                   * It takes a string like `"foo=bar, baz=qux"` and returns an object like `{foo:
                   * "bar", baz: "qux"}`
                   * @returns An object with the key being the first match and the value being the
                   * second match.
                   */
                  const parseAttrListCustom = input => {
                    let match
                    const attrs = {}
                    const quote = '"'
                    const ATTR_LIST_REGEX =
                      /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g
                    ATTR_LIST_REGEX.lastIndex = 0
                    while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
                      let value = match[2]

                      if (
                        value.indexOf(quote) === 0 &&
                        value.lastIndexOf(quote) === value.length - 1
                      ) {
                        value = value.slice(1, -1)
                      }

                      attrs[match[1]] = value
                    }
                    return attrs
                  }
                  const attr = parseAttrListCustom(tagArr[1])
                  if (
                    attr &&
                    Object.keys(attr).length &&
                    attr.hasOwnProperty('L')
                  ) {
                    if (G_CLICK_URL.current != attr.L) {
                      G_CLICK_URL.current = attr.L
                    }
                    break
                    // break when ASSET with URL found
                  }
                } catch (error) {
                  G_CLICK_URL.current = null
                }
              }

              // if last tag and ASSET tag not found set G_CLICK_URL to null
              if (i + 1 == obj.frag.tagList.length) {
                G_CLICK_URL.current = null
              }
            }
          }
        }
      )
    }
  }, [kalturaPlayer])

  useEventListener(
    PLAYER_EVENT.Core.FIRST_PLAY,
    FRAG_FIRST_PLAY_HANDLER,
    kalturaPlayer
  )

  const AD_SKIPPED_HANDLER = useCallback(() => {
    counterTimeWatch.resume()
    if (kalturaPlayer) {
      //show midroll
      if (inChanel26 && DFP_ADS_ON) {
        const timer = new Timer(() => {
          resetAfterMidroll()
          playAdNow('midroll')
        }, DFP_Timer_BB)
        setState({ timer: timer })
      }
    }
  }, [
    DFP_ADS_ON,
    DFP_Timer_BB,
    inChanel26,
    kalturaPlayer,
    playAdNow,
    resetAfterMidroll,
  ])
  useEventListener(
    PLAYER_EVENT.Core.AD_SKIPPED,
    AD_SKIPPED_HANDLER,
    kalturaPlayer
  )

  const PLAYING_HANDLER = useCallback(() => {
    if (kalturaPlayer) {
      setState({ showLoader: false })
      setVideoPlaying(true)
    }
  }, [kalturaPlayer, setVideoPlaying])
  useEventListener(PLAYER_EVENT.Core.PLAYING, PLAYING_HANDLER, kalturaPlayer)

  const USER_CLICKED_PLAY_HANDLER = useCallback(() => {
    if (kalturaPlayer && targetPlayNowArr[0] !== targetId) {
      setTargetPlayingNow(targetId, true)
    }
  }, [kalturaPlayer, setTargetPlayingNow, targetPlayNowArr, targetId])
  useEventListener(
    PLAYER_EVENT.UI.USER_CLICKED_PLAY,
    USER_CLICKED_PLAY_HANDLER,
    kalturaPlayer
  )

  const [setIsPlayerFullscreen, isPlayerFullscreen] = useRootStore(state => [
    state.setIsPlayerFullscreen,
    state.isPlayerFullscreen,
  ])
  const ENTER_FULLSCREEN_HANDLER = useCallback(() => {
    if (kalturaPlayer) {
      if (playerConfig.inWebView) {
        utils._postMessage('playerEnteringFullScreen')
      }
      setIsPlayerFullscreen(true)
    }
  }, [kalturaPlayer])
  useEventListener(
    PLAYER_EVENT.Core.ENTER_FULLSCREEN,
    ENTER_FULLSCREEN_HANDLER,
    kalturaPlayer
  )

  const EXIT_FULLSCREEN_HANDLER = useCallback(() => {
    if (kalturaPlayer) {
      if (playerConfig.inWebView) {
        utils._postMessage('playerExitingFullScreen')
      }
      setIsPlayerFullscreen(false)
    }
  }, [kalturaPlayer])
  useEventListener(
    PLAYER_EVENT.Core.EXIT_FULLSCREEN,
    EXIT_FULLSCREEN_HANDLER,
    kalturaPlayer
  )

  const ENTER_PICTURE_IN_PICTURE_HANDLER = useCallback(() => {
    if (kalturaPlayer) {
      setState({ isKalturaPicInPic: true })
    }
  }, [kalturaPlayer])
  useEventListener(
    PLAYER_EVENT.Core.ENTER_PICTURE_IN_PICTURE,
    ENTER_PICTURE_IN_PICTURE_HANDLER,
    kalturaPlayer
  )

  const LEAVE_PICTURE_IN_PICTURE_HANDLER = useCallback(() => {
    if (kalturaPlayer) {
      setState({ isKalturaPicInPic: false })
    }
  }, [kalturaPlayer])

  useEventListener(
    PLAYER_EVENT.Core.LEAVE_PICTURE_IN_PICTURE,
    LEAVE_PICTURE_IN_PICTURE_HANDLER,
    kalturaPlayer
  )

  // const animateOutPicInPic = (target: HTMLElement) => {
  //     if (target.classList.contains('pictureinpicturemode')) {
  //         target.classList.add('pictureinpicturemodeout')
  //         setTimeout(() => {
  //             target.classList.remove('pictureinpicturemode')
  //             target.classList.remove('pictureinpicturemodeout')
  //         }, 300)
  //     }
  // }
  //
  // const animateInPicInPic = useCallback(
  //     (target: HTMLElement) => {
  //         target.classList.add('pictureinpicturemode')
  //         target.classList.remove('pictureinpicturemodeout')
  //         creatCloseBtn(target)
  //     },
  //     [creatCloseBtn]
  // )
  //
  // const creatCloseBtn = (target: HTMLElement) => {
  //     if (!target.querySelector('.picInPicClose')) {
  //         const node = document.createElement('button') as HTMLElement
  //         node.classList.add('picInPicClose')
  //         node.addEventListener('click', () => {
  //             kalturaPlayer.pause()
  //             animateOutPicInPic(target)
  //             setState({isPicInPic: false, isTaboolaInView: false})
  //         })
  //         target.appendChild(node)
  //     }
  // }

  // const trackScrolling = useCallback(() => {
  //   let wrappedElement, video
  //   if (kalturaRef.current) {
  //     wrappedElement = document.getElementById(
  //       kalturaRef.current.id
  //     ) as HTMLElement
  //     video = document.querySelector(
  //       '#' + kalturaRef.current.id + ' video'
  //     ) as HTMLVideoElement
  //   }
  //   const el = document.querySelector(
  //     '#taboola-below-vod-thumbnails,#taboola-below-portal-thumbnails'
  //   ) as HTMLElement
  //   let videoPause = video ? video.paused : true
  //   if (isAdPlaying.current) {
  //     videoPause = false
  //   }
  //
  //   if (kalturaPlayer && utils.isMobile() && wrappedElement) {
  //     if (utils.outOfView(wrappedElement)) {
  //       if (!videoPause && document.pictureInPictureElement === null) {
  //         kalturaPlayer.pause()
  //         setState({
  //           isPlayingdInMobile: true,
  //           afterScrollPauseMobile: true,
  //         })
  //       } else if (state.isPlayingdInMobile) {
  //         setState({ isPlayingdInMobile: false })
  //       }
  //     } else if (!state.isPlayingdInMobile && state.afterScrollPauseMobile) {
  //       kalturaPlayer.play()
  //       setState({ afterScrollPauseMobile: false })
  //     }
  //   } else if (
  //     wrappedElement &&
  //     !state.isErrorVideoLoad &&
  //     !state.isKalturaPicInPic &&
  //     (!videoPause || state.isTaboolaInView || state.isPicInPic)
  //   ) {
  //     if (kalturaRef.current !== null) {
  //       const target = document.querySelector(
  //         '#' + kalturaRef.current.id + ' .kaltura-player-container '
  //       ) as HTMLElement
  //       const maxwidth = target.parentElement?.offsetWidth
  //       target.style.maxWidth = maxwidth + 'px'
  //
  //       if (utils.outOfView(wrappedElement)) {
  //         if (!state.isTaboolaInView) {
  //           if (el && utils.isTaboolaElementInView(el)) {
  //             kalturaPlayer.pause()
  //             animateOutPicInPic(target)
  //             setState({
  //               isPicInPic: false,
  //               isTaboolaInView: true,
  //             })
  //           } else {
  //             animateInPicInPic(target)
  //             setState({
  //               isPicInPic: true,
  //             })
  //           }
  //         }
  //       } else {
  //         if (state.isTaboolaInView) {
  //           kalturaPlayer.play()
  //           setState({ isTaboolaInView: false })
  //         }
  //         animateOutPicInPic(target)
  //         setState({ isPicInPic: false })
  //       }
  //     }
  //   }
  // }, [
  //   state.isPicInPic,
  //   state.isTaboolaInView,
  //   animateInPicInPic,
  //   isAdPlaying.current,
  //   state.isErrorVideoLoad,
  //   state.isKalturaPicInPic,
  //   kalturaPlayer,
  //   state.isPlayingdInMobile,
  //   state.afterScrollPauseMobile,
  // ])
  //
  // useEventListener('scroll', trackScrolling, window)

  const sendTimeWatchLive = () => {
    const newDate = new Date()
    gtag('event', 'live_watch_duration', {
      content_id: videoRef,
      user_id: getUuid(),
      platform: getAdDeviceType(),
      duration_sec: counterTimeWatch.getState().time,
      timestamp: newDate.toISOString(),
      transport_type: 'beacon',
    })
    counterTimeWatch.stop()
  }

  const MEDIA_ENDED_CORE = useCallback(() => {
    if (
      pageType === 'pageLive' ||
      pageType === 'live' ||
      inChanel26 ||
      isLiveVideo
    ) {
      const newDate = new Date()
      sendGA4({
        eventName: 'live_watch_duration',
        pageData: pageData,
        content_id: videoRef,
        user_id: getUuid(),
        platform: getAdDeviceType(),
        duration_sec: counterTimeWatch.getState().time,
        timestamp: newDate.toISOString(),
      })
      counterTimeWatch.stop()
    }
  }, [
    videoRef,
    counterTimeWatch,
    pageData,
    getAdDeviceType,
    pageType,
    inChanel26,
  ])
  useEventListener(PLAYER_EVENT.Core.ENDED, MEDIA_ENDED_CORE, kalturaPlayer)

  useEffect(() => {
    isComponentMounted.current = true
    return () => {
      isComponentMounted.current = false
    }
  }, [])

  useEffect(() => {
    isPaused.current = playerStatePaused
  }, [playerStatePaused])

  const handleMouseMove = useCallback(() => {
    marqueTitleTimeout.current && clearTimeout(marqueTitleTimeout.current)

    if (!state.isPicInPic) {
      setDisplayMarqueTitle('flex')
      hidePlayerTitle()
    }
  }, [])

  const handleMouseLeave = useCallback(() => {
    marqueTitleTimeout.current && clearTimeout(marqueTitleTimeout.current)
    if (!isPaused.current) {
      setDisplayMarqueTitle('none')
    }
  }, [])

  const hidePlayerTitle = useCallback(() => {
    marqueTitleTimeout.current = setTimeout(() => {
      if (!isPaused.current) {
        setDisplayMarqueTitle('none')
      }
    }, 3000)
  }, [])

  useEffect(() => {
    if (kalturaRef.current && !beforePlaying) {
      kalturaRef.current.addEventListener('mousemove', handleMouseMove)
      kalturaRef.current.addEventListener('mouseleave', handleMouseLeave)
      kalturaRef.current.addEventListener('touchstart', handleMouseMove, {
        passive: true,
      })
    }

    return () => {
      if (kalturaRef.current && beforePlaying) {
        kalturaRef.current.removeEventListener('touchstart', handleMouseMove)
        kalturaRef.current.removeEventListener('mousemove', handleMouseMove)
        kalturaRef.current.removeEventListener('mouseleave', handleMouseLeave)
        // removeOmidEvents(kalturaRef.current)
      }
    }
  }, [kalturaRef.current, playerStatePaused, beforePlaying])

  const liveSource = useLiveSource({
    enabled: isLiveVideo && !inChanel26,
    liveSources: clientConfig.liveSources,
    subTitlesOn: !!props.subTitlesOn,
    googlePal,
    googlePalReady,
    ppid,
  })

  useEffect(() => {
    if (palVideoElement && kalturaPlayer) {
      const container = palVideoElement.querySelector(
        '.kaltura-player-container'
      )
      if (container) {
        setKalturaContainer(container as HTMLElement)
      }
    }
  }, [kalturaPlayer, palVideoElement])

  //kaltura config
  useEffect(() => {
    if (!state.adsFetched && !(inChanel26 || isLiveVideo)) {
      return
    }
    if (isLiveVideo && !inChanel26 && !liveSource) {
      return
    }
    if (window.KalturaPlayer && kalturaRef.current) {
      let embedUrl = `${location.protocol}//${location.host}/embed${window.location.pathname}`
      embedUrl = utils.insertParam('ref', videoRef, embedUrl)
      embedUrl = utils.insertParam('k_id', kalturaId, embedUrl)
      embedUrl = utils.insertParam('duration', contentDuration, embedUrl)
      embedUrl = utils.insertParam('poster', poster, embedUrl)

      let livePageConfig = {}
      const shareConfig: IShareConfig = {
        disable: false,
        embedUrl: embedUrl,
        shareUrl: window.location.href,
      }

      //live page config
      if (
        pageType === 'pageLive' ||
        pageType === 'live' ||
        inChanel26 ||
        isLiveVideo
      ) {
        livePageConfig = {
          dvr: true,
          type: 'Live',
          playback: {
            autoplay: autoPlay ? 'inview' : autoPlay,
            inBrowserFullscreen: enable_full_screen,
            screenLockOrientionMode: playerConfig.inWebView && 'landscape',
          },
        }
        //to disable share
        shareConfig.disable = true
      }
      if (pageData?.isPlayerEmbed) {
        shareConfig.disable = true
      }
      try {
        const config = kalturaConfig({
          targetId,
          autoPlay: autoPlay ? 'inview' : autoPlay,
          enable_full_screen,
          shareConfig,
          livePageConfig,
          bitrate: pageData.SiteMeta.config?.player?.bitrate || '720',
        })

        if (DFP_ADS_ON) {
          config.plugins = {
            ...config.plugins,
            ima: {
              locale: 'he',
              adsRenderingSettings: {
                uiElements: ['adAttribution', 'countdown'],
              },
              enableOmid: true,
              omidAccessModes: {
                OTHER: 'FULL',
                DOUBLEVERIFY: 'FULL',
              },
              ppid: ppid,
            },
          }
          if (isLiveVideo && !inChanel26) {
            if (clientConfig.live_ima === 'enabled') {
              config.plugins = {
                ...config.plugins,
                ima: {
                  ...config.plugins.ima,
                  adTagUrl: dfpUtils.getAdVideo({
                    pagetypeMeta: pageType,
                    pageType: 'live',
                    adType: 'preroll',
                    levels,
                    item,
                    googlePal: googlePalRef.current,
                    pageViewedInDay: pageViewedInDay.pageViewInDayCount,
                    referenceId: videoRef,
                  }),
                },
              }
              if (clientConfig.live_mid_rolls === 'enabled') {
                const cookies = new Cookies()
                const accessibilityOn = cookies.get(
                  subtitlesData.video_accessibility_cookie_name
                )
                const assetKey = dfpUtils.geAssetKey(country, videoRef)
                const custParams = dfpUtils.getCustParams({
                  pageType,
                  levels,
                  DFPType: 'midrollLive',
                  pageViewedInDay: pageViewedInDay.pageViewInDayCount,
                  item,
                  referenceId: videoRef,
                })

                config.plugins.imadai =
                  accessibilityOn === 'true'
                    ? { disable: true }
                    : {
                        assetKey: assetKey,
                        debug: true,
                        adTagParameters: {
                          cust_params: custParams,
                        },
                      }
              }
            } else {
              delete config.plugins.ima //mid rolls
              delete config.plugins.imadai //pre rolls
            }
          }
        }

        if (poster) {
          config.sources.poster = poster
        }

        let kalturaPlayer = window.KalturaPlayer.getPlayer(targetId)
        if (kalturaPlayer !== null) {
          kalturaPlayer.destroy()
        }
        try {
          if (isLiveVideo && !inChanel26) {
            config.sources = {
              ...config.sources,
              hls: [
                {
                  id: '1_ufpwi64o,applehttp',
                  mimetype: 'application/x-mpegURL',
                  url: liveSource.source,
                },
              ],
              dvr: true,
              dash: [
                {
                  id: '1_ufpwi64o,mpegdash',
                  mimetype: 'application/dash+xml',
                  url: liveSource.source,
                },
              ],
            }
            config.plugins.kava = { entryId: kalturaId }
          }

          // 'inview' like the config above: `true` started (and requested the
          // preroll for) a player below the fold the moment it was set up
          config.playback.autoplay = props.autoPlay ? 'inview' : 0

          kalturaPlayer = window.KalturaPlayer.setup(config)

          if (DFP_ADS_ON) {
            setImaPpid(ppid)
          }

          // kalturaPlayer.addEventListener('adbreakstart', () => {
          //   setTimeout(() => {
          //     if (kalturaPlayer.volume != 0) {
          //       kalturaPlayer.volume -= 0.05
          //       kalturaPlayer.volume += 0.05
          //     }
          //     // document.body.style.backgroundColor = 'lightblue';
          //   }, 500) // 2000 ms = 2 seconds
          // })

          if (
            kantarSiteName &&
            isLiveVideo &&
            !inChanel26 /* && ["prod", "staging"].includes(utils.getEnv())*/
          ) {
            const kantarConfig = {
              siteName: kantarSiteName,
              streamName: 'channel13',
            }
            try {
              window.KalturaPlayer.plugins.kantar.track(
                kalturaPlayer,
                kantarConfig
              )
            } catch (e) {
              console.log(
                '%cKaltura',
                'background-color:darkred;color:white;padding:2px 5px;',
                e
              )
            }
          }

          if (isLiveVideo && !inChanel26) {
            // started here (not by Kaltura) so the start event is not missed;
            // a player off screen is left to the 'inview' autoplay instead
            const box = kalturaRef.current?.getBoundingClientRect()
            const onScreen =
              !!box && box.top < window.innerHeight && box.bottom > 0
            if (autoPlay && isDesktop() && onScreen) {
              setVideoPlaying(true)
              GA4VideoStartEvent()
              kalturaPlayer.play()
              setState({ playBackStart: true })
            }
          } else {
            // a media that cannot be loaded shows the error image instead of
            // an empty player (and no uncaught rejection)
            const player = kalturaPlayer
            Promise.resolve(player.loadMedia({ entryId: kalturaId })).catch(
              (e: unknown) => {
                // destroyed while loading (the user left the page): not an error
                if (window.KalturaPlayer?.getPlayer?.(targetId) !== player) {
                  return
                }
                prettyLog('Kaltura: loadMedia', { e, kalturaId }, 'error')
                setState({ isErrorVideoLoad: true })
              }
            )
          }

          setOmidEvents(kalturaPlayer)
          kalturaPlayer.ready().then(() => {
            setState({ loadTaboola: true })

            // //add AdFlag
            // if (kalturaRef.current !== null) {
            //   const adFlaf = '<div class="adFlag">יצאנו לפרסומות</div>'
            //   kalturaRef.current.firstElementChild?.insertAdjacentHTML(
            //     'afterbegin',
            //     adFlaf
            //   )
            // }

            //hide quality menu on mouse out
            utils.hideQualityMenu(targetId)

            //full screen hide bottom bar
            if (kalturaRef !== null && kalturaRef.current !== null) {
              kalturaRef.current.addEventListener('mousemove', () => {
                if (kalturaRef.current !== null) {
                  utils.hideBottomMenu(kalturaRef.current)
                }
              })
            }
          })
          setKalturaPlayer(kalturaPlayer)
        } catch (e) {
          prettyLog('Kaltura: 1265', [e, kalturaPlayer], 'error')
        }
      } catch (e: any) {
        prettyLog('Kaltura: 1435', { e }, 'error')

        setState({ isErrorVideoLoad: true })
      }
    }
  }, [
    DFP_ADS_ON,
    autoPlay,
    contentDuration,
    country,
    inChanel26,
    item,
    kalturaId,
    levels,
    loadKantarConfig,
    pageType,
    // pageViewedInDay,
    poster,
    playerScript.kantarReady,
    targetId,
    videoRef,
    window.KalturaPlayer,
    liveSource,
    ppid,
    state.adsFetched,
  ])

  useEffect(() => {
    if (
      kalturaPlayer &&
      targetPlayNowArr[0] !== targetId &&
      targetPlayNowArr.length > 0
    ) {
      kalturaPlayer.pause()
    }
  }, [kalturaPlayer, targetPlayNowArr, targetId])

  const playAd = (ad: string) => {
    kalturaPlayer.ads.playAdNow([{ url: [ad] }])
  }

  useEffect(() => {
    const handleBeforeUnload = () => {
      sendTimeWatchLive()
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  useEffect(() => {
    setAdsCollection()
    const handleBeforeUnload = () => {
      const newDate = new Date()
      gtag('event', 'live_watch_duration', {
        content_id: videoRef,
        user_id: getUuid(),
        pageData: pageData,
        platform: getAdDeviceType(),
        duration_sec: counterTimeWatch.getState().time,
        timestamp: newDate.toISOString(),
        transport_type: 'beacon',
      })
      counterTimeWatch.stop()
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  useUnmount(() => {
    if (
      pageType === 'pageLive' ||
      pageType === 'live' ||
      inChanel26 ||
      isLiveVideo
    ) {
      const newDate = new Date()
      sendGA4({
        eventName: 'live_watch_duration',
        pageData: pageData,
        content_id: videoRef,
        user_id: getUuid(),
        platform: getAdDeviceType(),
        duration_sec: counterTimeWatch.getState().time,
        timestamp: newDate.toISOString(),
      })
      counterTimeWatch.stop()
    }
    // if (omidManagerRef.current) {
    //   omidManagerRef.current.cleanup()
    //   omidManagerRef.current = null
    // }

    // the player (hls, IMA, its timers) goes with the page: after a
    // client-side navigation it used to stay alive in the background
    dfp_timer.stop()
    interval.current && clearTimeout(interval.current)
    marqueTitleTimeout.current && clearTimeout(marqueTitleTimeout.current)
    try {
      kalturaPlayer?.destroy()
    } catch (e) {
      prettyLog('Kaltura: destroy', { e }, 'error')
    }
  })

  const setAdsCollection = () => {
    if (!(inChanel26 || isLiveVideo)) {
      const adVmapTest = getParameterByName('ad_vmap_test')

      const ad =
        adVmapTest === 'no_error'
          ? '/static/ads/vmap_no_error.xml'
          : adVmapTest === 'preroll_error'
          ? '/static/ads/vmap_preroll_error.xml'
          : adVmapTest === 'midroll_error'
          ? '/static/ads/vmap_midroll_error.xml'
          : adVmapTest === 'yael_test'
          ? 'https://pubads.g.doubleclick.net/gampad/ads?iu=/36476105/test_video/TestV&description_url=https%3A%2F%2F13tv.co.il%2F&tfcd=0&npa=0&sz=640x480&gdfp_req=1&unviewed_position_start=1&output=vmap&ad_rule=1&env=vp&impl=s&correlator='
          : dfpUtils.getAdVideo({
              pagetypeMeta: pageType,
              pageType: 'vod',
              levels,
              pageViewedInDay: pageViewedInDay.pageViewInDayCount,
              item,
              referenceId: videoRef,
              environment: clientConfig.adTargetEnv,
              videoDurationSec: contentDuration,
            }) +
            '&vid=' +
            dfpUtils.AdVidDur(contentDuration)
      const ads = dfpUtils.parseAdsIntoCollection(ad)
      ads
        .then((data: AdS) => {
          adStorage.current = data
        })
        .finally(() => {
          setState({ adsFetched: true })
        })
    }
  }

  // useEffect(() => {
  //   if (kalturaPlayer && utils.isMobile()) {
  //     if (kalturaRef.current) {
  //       const wrappedElement = document.getElementById(
  //         kalturaRef.current.id
  //       ) as HTMLElement
  //       if (isPageVisible) {
  //         if (state.afterPageIsNotVisible && !utils.outOfView(wrappedElement)) {
  //           if (!state.wasPaused) {
  //             kalturaPlayer.play()
  //           }
  //           setState({ afterPageIsNotVisible: false })
  //         }
  //       } else if (!state.afterPageIsNotVisible) {
  //         const wasPaused = kalturaPlayer.paused
  //         kalturaPlayer.pause()
  //         setState({
  //           afterPageIsNotVisible: true,
  //           wasPaused: wasPaused,
  //         })
  //       }
  //     }
  //   }
  // }, [kalturaPlayer, isPageVisible, autoPlay, state.afterPageIsNotVisible])

  const getNextVideoTitle = () => {
    if (videos.current[1]) {
      return videos.current[1].videoTitle
    }
    return ''
  }

  const getCurrentVideoTitle = () => {
    return videos.current[0].videoTitle
  }

  const playNextVideo = () => {
    if (!isComponentMounted.current) return

    const { videoTitle, kalturaId } = videos.current[0]
    interval.current && clearTimeout(interval.current)
    setDelayTimeEnded(true)
    setReplayClicked(false)
    nextVideoTimer.stop()
    replayVideo.current = kalturaId
    NextVideoTimerScreenMarqueTitle.current = videoTitle
    sendGA4({
      eventName: isNativeApp() ? 'appnext_video_loader' : 'next_video_loader',
      pageData: pageData,
      url: pageData.Content.Item?.link,
      current_video_title: getCurrentVideoTitle(),
      next_video_title: getNextVideoTitle(),
      num: autoPlayedItemsCounter.current++,
    })
    setPlayerTitle(videoTitle || '')
    kalturaPlayer.loadMedia({ entryId: kalturaId }).then(() => {
      if (isComponentMounted.current) kalturaPlayer.play()
    })
    const videosList = [...videos.current]
    videosList.shift()
    videos.current = [...videosList]
  }

  const replayPreviousVideo = (entryId: string) => {
    setDelayTimeEnded(true)
    setReplayClicked(true)
    interval.current && clearTimeout(interval.current)
    nextVideoTimer.stop()
    kalturaPlayer.loadMedia({ entryId: entryId }).then(() => {
      kalturaPlayer.play()
    })
  }

  useEffect(() => {
    setShowNextVideoSlide(
      videoEnded &&
        !delayTimeEnded &&
        videos.current &&
        Object.entries(videos.current).length > 0 &&
        playNextVideoIsOn &&
        kalturaContainer &&
        !state.isPicInPic
    )
  }, [videoEnded, delayTimeEnded])

  // OMID Manager for ad verification
  // const omidManagerRef = useRef<OmidManager | null>(null)

  // Simple tracking data state for OMID
  // const [trackingData, setTrackingData] = useState<AdTrackingData | null>(null)

  // useEffect(() => {
  //   if (kalturaPlayer && !isAdPlaying.current) {
  //     // Try to initialize OMID Manager when the player container is ready
  //     if (!omidManagerRef.current && typeof OmidManager === 'function') {
  //       const localPlayer = (
  //         kalturaPlayer as KalturaPlayer & { _localPlayer?: ILocalPlayer }
  //       )._localPlayer
  //       const videoElement = localPlayer?._el?.querySelector(
  //         'video'
  //       ) as HTMLVideoElement | null
  //       if (videoElement) {
  //         try {
  //           omidManagerRef.current = new OmidManager(videoElement)
  //
  //           // Set tracking data if already available
  //           if (trackingData) {
  //             omidManagerRef.current.setAdTrackingData(trackingData)
  //           }
  //         } catch (error) {
  //           console.error(
  //             'OMID: Error initializing manager via container:',
  //             error
  //           )
  //         }
  //       }
  //     }
  //   }
  // }, [kalturaPlayer])

  // // Handle player pause when less than 50% visible
  useEffect(() => {
    if (!kalturaPlayer) {
      return
    }
    if (state.playBackStart && !state.isKalturaPicInPic) {
      if (
        (kalturaPlayer.paused &&
          (outOfViewPaused.current || state.isAdPlaying)) ||
        (!kalturaPlayer.paused && !outOfViewPaused.current)
      ) {
        if (
          (!inView || !isPageVisible) &&
          ['playing', 'ended', 'paused', 'not_playing'].includes(
            adPlayerStatus.current
          )
        ) {
          if (adPlayerStatus.current === 'paused') {
            return
          }
          kalturaPlayer.pause()
          outOfViewPaused.current = true
          if (state.isAdPlaying) {
            try {
              kalturaPlayer.plugins.ima.pauseAd()
            } catch (e) {
              prettyLog('Kaltura: 1778', { e })
            }
            sendGA4({
              eventName: `${isLiveVideo ? 'live_' : ''}pause_focus`,
              pageData: pageData,
              video_duration: contentDuration,
              ReferenceId: videoRef,
              is_autoplay: autoPlay ? 'yes' : 'no',
            })
          }
        } else {
          if (outOfViewPaused.current) {
            outOfViewPaused.current = false
            if (state.isAdPlaying) {
              try {
                kalturaPlayer.plugins.ima.resumeAd()
              } catch (e) {
                prettyLog('Kaltura: 1788', { e })
              }

              sendGA4({
                eventName: `${isLiveVideo ? 'live_' : ''}play_focus`,
                pageData: pageData,
                video_duration: contentDuration,
                ReferenceId: videoRef,
                is_autoplay: autoPlay ? 'yes' : 'no',
              })
            } else {
              kalturaPlayer.play()
            }
          }
        }
      }
    }
  }, [
    isPageVisible,
    inView,
    kalturaPlayer,
    state.isKalturaPicInPic,
    state.playBackStart,
    state.isAdPlaying,
  ])

  // Fallback initialization - create manager without video element if needed
  // useEffect(() => {
  //   if (
  //     kalturaPlayer &&
  //     !omidManagerRef.current &&
  //     typeof OmidManager === 'function'
  //   ) {
  //     // Wait to let other initialization methods try first
  //     const fallbackTimer = setTimeout(() => {
  //       if (!omidManagerRef.current) {
  //         // Create a temporary video element for initialization
  //         const tempVideo = document.createElement('video')
  //         try {
  //           omidManagerRef.current = new OmidManager(tempVideo)
  //           // Set tracking data if already available
  //           if (trackingData) {
  //             omidManagerRef.current.setAdTrackingData(trackingData)
  //           }
  //
  //           // Try to update with real video element when available
  //           const updateWithRealVideo = () => {
  //             // Wait for the player's DOM element to be ready
  //             const localPlayer = (
  //               kalturaPlayer as KalturaPlayer & { _localPlayer?: ILocalPlayer }
  //             )?._localPlayer
  //             if (!localPlayer?._el) {
  //               return false
  //             }
  //
  //             const realVideo = localPlayer._el.querySelector(
  //               'video'
  //             ) as HTMLVideoElement
  //             if (realVideo && omidManagerRef.current) {
  //               omidManagerRef.current.updateVideoElement(realVideo)
  //               // Set tracking data if available
  //               if (trackingData) {
  //                 omidManagerRef.current.setAdTrackingData(trackingData)
  //               }
  //               return true
  //             }
  //             return false
  //           }
  //
  //           // Poll for real video element with longer timeout
  //           const pollInterval = setInterval(() => {
  //             const isUpdated = updateWithRealVideo()
  //             if (isUpdated) {
  //               clearInterval(pollInterval)
  //             }
  //           }, 100)
  //
  //           const timeout = setTimeout(() => {
  //             clearInterval(pollInterval)
  //           }, 15000) // search for video element for 15 seconds
  //
  //           return () => {
  //             clearInterval(pollInterval)
  //             clearTimeout(timeout)
  //           }
  //         } catch (error) {
  //           console.error(
  //             'OMID: Error initializing manager with temporary video:',
  //             error
  //           )
  //         }
  //       }
  //     }, 1000) // Wait 1 second before trying fallback
  //
  //     return () => clearTimeout(fallbackTimer)
  //   }
  // }, [kalturaPlayer, trackingData])

  if (
    clientConfig.bigBrotherRegistration === 'on' &&
    inChanel26 &&
    !isUserLoggedIn()
  ) {
    return <RegistrationFormCTA title={'האח הגדול לייב'} />
  }

  const getPlayerTitle = () => {
    if (fromParser) {
      return title
    }
    if (playerTitle) {
      return playerTitle
    }
    if (pageData.Content.Item?.video.description) {
      return pageData.Content.Item?.video.description
    }
    return pageData.Content.Item?.title
  }

  return (
    <KlaturaPlayerWrp
      ref={setRefs}
      className={cx(['wrp-kaltura', 'player-con'])}
      theme={{ showingAd: isAdPlaying.current }}
      data-kid={kalturaId}
      data-name={videoRef}
      data-autoplay={autoPlay}
      key={kalturaId}
    >
      {isDesktop() &&
        !isLiveVideo &&
        !isAdPlaying.current &&
        kalturaContainer &&
        ReactDOM.createPortal(
          <GradientContainer
            display={displayMarqueTitle}
            className={isPlayerFullscreen ? 'full-screen' : ''}
          >
            <PlayerMarqueTitle
              className={'playerMarquee ' + 'full-screen-' + isPlayerFullscreen}
              fontSize={utils.isMobile() ? 14 : isPlayerFullscreen ? 36 : 21}
              width={isPlayerFullscreen ? '100%' : '800px'}
              color={'#fff'}
              text={
                replayClicked
                  ? NextVideoTimerScreenMarqueTitle.current
                  : getPlayerTitle()
              }
              speed={30}
              display={displayMarqueTitle} //'flex'
            />
          </GradientContainer>,
          kalturaContainer
        )}
      {showNextVideoSLide &&
        ReactDOM.createPortal(
          <NextVideoTimerScreen
            isPlayerFullscreen={isPlayerFullscreen}
            playerTitle={
              replayClicked
                ? NextVideoTimerScreenMarqueTitle.current
                : getPlayerTitle()
            }
            replayVideo={replayVideo.current}
            nextVideo={videos.current[0]}
            playNextVideoInterval={playNextVideoInterval}
            replayPreviousVideo={replayPreviousVideo}
            playNextVideo={playNextVideo}
          />,
          kalturaContainer
        )}

      {state.isErrorVideoLoad ? (
        <ImgWithRatio
          loading='lazy'
          kalturaClass={'kalturaImgErr'}
          src={state.isErrorOverseas ? overseasImg : defaultImg}
          alt='error loading video'
        />
      ) : (
        <KlaturaPlayerDiv
          ref={kalturaRef}
          id={targetId}
          key={targetId}
          theme={{ show: playerStatePaused }}
        />
      )}
      {/* the error image replaces the player: no spinner over it */}
      <Loader showLoader={state.showLoader && !state.isErrorVideoLoad} />
    </KlaturaPlayerWrp>
  )
}
export default Kaltura
